export interface Profile {
    id: number;
    email: string | null;
    uid: string | null;
    self: number;
}

export const InitProfile: Profile = {
    id: 0,
    email: null,
    uid: null,
    self: 0
}
